








































































































































































































































































import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import Utils from '@/utils/common';
import * as _ from 'lodash';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import moment from 'moment';
import {
  queryParkingspacePackageEditInfo,
  queryParkingSpaceAreaInfo,
  queryParkingspacePackageEdit
} from '../../../api/parking-space-list';
import {
  packageFixedMap,
  packageCVerifyMap,
  packageUseTypeMap,
  shidaillPackageUseTypeMap,
  categoryMap,
  packageTypeMap,
  packageCTypeMap,
  packageClinetNumberTypeMap,
  packageAuthorizationTypeMap,
  packageCVerifyNewMap,
  optionalParkingNumberMap,
  packageCVerifyRenewMap,
  weekDescList,
  packagetCTypeMap
} from '../../../types/parking-space-management/dictionaries';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import { isShiDaill } from '@root/utils/env';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: {
    ParkingLotSearch
  }
})
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  path = '/smart-parking/parking-space-management/charging-package';
  // 判断是否是时代邻里
  isshidaill: boolean = isShiDaill;
  // 面板屑
  private navs: any = [
    {
      label: '车位固定收费套餐',
      location: {
        name: routeNames.CHARGING_PACKAGE
      }
    },
    {
      label: '修改收费套餐'
    }
  ];
  // map -> list
  // 是否固定车位、是否需后台审核、车位用途、车位类别、套餐类型、C端可办理业务、C端可办理车位数、授权时段方式、线上开卡是否需后台审核、线上续费是否需后台审核
  packageFixedList = Utils.toLabelVal(packageFixedMap);
  packageCVerifyList = Utils.toLabelVal(packageCVerifyMap);
  packageUseTypeList = Utils.toLabelVal(packageUseTypeMap);
  categoryList = Utils.toLabelVal(categoryMap);
  packageTypeList = Utils.toLabelVal(packageTypeMap);
  packageCTypeList = Utils.toLabelVal(packageCTypeMap);
  // packageCTypeList = Utils.toLabelVal(packagetCTypeMap);
  packageCVerifyNewList = Utils.toLabelVal(packageCVerifyNewMap);
  OptionalParkingNumberList = Utils.toLabelVal(optionalParkingNumberMap);
  packageCVerifyRenewList = Utils.toLabelVal(packageCVerifyRenewMap);
  packageClinetNumberTypeList = Utils.toLabelVal(packageClinetNumberTypeMap);
  packageAuthorizationTypeList = Utils.toLabelVal(packageAuthorizationTypeMap);

  // form布局
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };

  // 按钮加载
  private loading: boolean = false; // 接口状态

  // form表单
  private updateForm: any;

  // 错时卡时间段
  private timeIntervalsList: any = [];

  // 授权区域列表
  private areaList: any = [];

  queryParkingSpaceAreaList: any = function() {}; // 区域列表防抖请求

  private packageId: string = ''; // 唯一packageId

  // 请求字段
  private filterParam: any = {
    parkId: '',
    areaIds: [], // 授权区域
    fixed: '', // 是否固定车位
    cVerify: '', // 是否需后台审核 01：是 02：否
    cVerifyNew: '', // 线上开卡是否需后台审核 01：是 02：否
    choiceSpace: '01', // C端开卡用户是否可自选车位号 01：是 02：否
    // cVerifyRenew: '', // 线上续费是否需后台审核 01：是 02：否
    name: '', // 套餐名称
    useType: '', // 车位用途
    category: '', // 车位类别
    period: 1, // 授权周期
    price: '', // 套餐价格
    type: '', // 套餐类型 01：全天卡 02：错时
    cType: [], // C端可办理业务 01：线上开卡 02：线上续费
    // clinetNumberType: '', // C端可办理车位数 01:车位总数-平台月卡已用车位数 02：设置独立最大数量
    clientNumber: '', // C端可办理车位数-设置独立最大值
    message: '', // 套餐说明
    authorizationType: '', // 授权时段方式 01：每天相同 02：每天不同
    timeIntervals: '' // 授权时段方式--错时卡时段
  };

  created() {
    // 初始化addForm
    this.updateForm = this.$form.createForm(this);
    // 区域列表
    this.queryParkingSpaceAreaList = _.debounce(this.queryParkingSpaceAreaInfo, 500);
    // 接收id，获取修改详情
    const packageId = this.$route.params.id;
    this.packageId = packageId;
    this.getPackageEditInfo();
  }

  beforeDestroy() {
    console.debug('debug:update', 'destroydestroydestroy');
  }

  destroyed() {
    console.debug('debug:update', 'destroyed');
  }

  private async getPackageEditInfo() {
    // 获取数据
    try {
      const { data } = await queryParkingspacePackageEditInfo({
        packageId: this.packageId
      });
      console.log(data, 'date------>>>>>');
      if (data.useType === '01') {
        this.packageCTypeList = Utils.toLabelVal(packagetCTypeMap);
      } else {
        this.packageCTypeList = Utils.toLabelVal(packageCTypeMap);
      }
      this.filterParam = data;
      this.timeIntervalsList = (function(arr) {
        return arr.map((item: { startTime: null; endTime: null }) => ({
          ...item,
          startTime: item.startTime == null ? '00:00' : item.startTime,
          endTime: item.endTime == null ? '00:00' : item.endTime
        }));
      })(data.timeIntervals);
    } catch (error) {
      this.$message.error(error.msg);
    }
  }

  // 车场变化，请求区域
  @Watch('filterParam.parkId')
  onChangeParkId(newVal: string, oldVal: string) {
    this.queryParkingSpaceAreaList();
  }

  // 获取区域数据
  async queryParkingSpaceAreaInfo() {
    try {
      const { parkId } = this.filterParam;
      const { data } = await queryParkingSpaceAreaInfo({
        parkId
      });
      this.areaList = data;
    } catch (error) {
      this.$message.error(error.msg);
    }
  }

  // 处理套餐类型转换：全天卡、错时卡
  private changeType(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.type = clinetValue;
    if (clinetValue === '01') {
      this.filterParam.authorizationType = '';
    }
  }

  // 处理错时卡授权时段方式
  private changeAuthorizationType(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.authorizationType = clinetValue;
  }

  // 错时卡授权时段方式
  @Watch('filterParam.authorizationType')
  onChangeAuthorizationType(newVal: string, oldVal: string) {
    // TODO: 这里有bug
    switch (newVal) {
      case '':
        this.timeIntervalsList = [];
        break;
      case '01':
        if (!oldVal) {
          this.timeIntervalsList = [
            {
              week: '',
              startTime: moment(this.timeIntervalsList[0].startTime, 'HH:mm'),
              endTime: moment(this.timeIntervalsList[0].endTime, 'HH:mm')
            }
          ];
        } else {
          this.timeIntervalsList = [];
          this.timeIntervalsList = [
            { week: '', startTime: moment('00:00', 'HH:mm'), endTime: moment('23:59', 'HH:mm') }
          ];
        }
        break;
      case '02':
        if (oldVal) {
          this.timeIntervalsList = [];
          weekDescList.forEach(item => {
            this.timeIntervalsList.push({
              week: item,
              startTime: moment('00:00', 'HH:mm'),
              endTime: moment('23:59', 'HH:mm')
            });
          });
        } else {
          this.timeIntervalsList = this.timeIntervalsList.map((item: any) => {
            return {
              ...item,
              week: weekDescList[item.week - 1],
              startTime: moment(item.startTime, 'HH:mm'),
              endTime: moment(item.endTime, 'HH:mm')
            };
          });
        }
        break;
      default:
        this.timeIntervalsList = [];
    }
  }

  // 处理车位用途为产权车位时
  private changeUseType(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.useType = clinetValue;
    if (clinetValue === '01') {
      this.filterParam.type = '01';
      this.updateForm.setFieldsValue({
        'filterParam.type': '01',
        'filterParam.fixed': '01'
      });
    }
    console.log(e.target.value, '000-----');
    if (e.target.value === '01') {
      this.packageCTypeList = Utils.toLabelVal(packagetCTypeMap);
    } else {
      this.packageCTypeList = Utils.toLabelVal(packageCTypeMap);
    }
    this.updateForm.setFieldsValue({
      'filterParam.cType': []
    });
    this.filterParam.cType = [];
  }

  // 处理C端可办理业务
  private changeCType(e: any) {
    const clinetValue = e;
    this.filterParam.cType = clinetValue;
  }

  // 处理C端可办理车位数
  private changeClinetNumberType(e: any) {
    const clinetValue = e.target.value;
    // this.filterParam.clinetNumberType = clinetValue;
  }

  // 提交
  private handleSubmit(e: any) {
    e.preventDefault();
    const { parkId } = this.filterParam;
    if (!parkId) {
      this.$message.warning('请选择车场');
      return;
    }
    this.updateForm.validateFields((err: any, values: any) => {
      if (!err) {
        const { filterParam } = values;
        this.add(filterParam);
      }
    });
  }

  // 提交接口
  private async add(params: any) {
    this.loading = true;
    const { parkId, clientNumber } = this.filterParam;
    // 处理错时卡时间段
    const paramsOptions = {
      ...params,
      parkId,
      price: params.price,
      // price: parseInt(params.price),
      timeIntervals: this.handleTimeIntervalsList(),
      areaIds: params.areaIds.join(','),
      cType: params.cType.join(','),
      clientNumber,
      pkPackageId: this.packageId
    };
    try {
      const { data } = await queryParkingspacePackageEdit({ ...paramsOptions });
      this.$message.success('修改成功');
      setTimeout(() => {
        this.toBack();
      }, 1000);
    } catch (error) {
      this.$message.error(error.msg);
    } finally {
      this.loading = false;
    }
  }

  // 提交前，处理错时卡时间段
  private handleTimeIntervalsList() {
    const { authorizationType } = this.filterParam;
    let timeIntervalsListTemp: any = [];
    switch (authorizationType) {
      // 全天相同
      case '01':
        weekDescList.forEach((item, index) => {
          timeIntervalsListTemp.push({
            week: index + 1,
            startTime: moment(this.timeIntervalsList[0].startTime).format('HH:mm'),
            endTime: moment(this.timeIntervalsList[0].endTime).format('HH:mm')
          });
        });
        break;
      // 周一到周日
      case '02':
        this.timeIntervalsList.forEach((item: any, index: any) => {
          timeIntervalsListTemp.push({
            week: index + 1,
            startTime: moment(item.startTime).format('HH:mm'),
            endTime: moment(item.endTime).format('HH:mm')
          });
        });
        break;
      default:
        timeIntervalsListTemp = [];
    }
    return timeIntervalsListTemp.map(
      (item: {
        startTime: {
          trim: () => { (): any; new (): any; replace: { (arg0: RegExp, arg1: string): number; new (): any } };
        };
        endTime: {
          trim: () => { (): any; new (): any; replace: { (arg0: RegExp, arg1: string): number; new (): any } };
        };
      }) => ({
        ...item,
        startTime:
          item.startTime.trim().replace(/:/g, '') - 0 == 0 && 0 == item.endTime.trim().replace(/:/g, '') - 0
            ? null
            : item.startTime,
        endTime:
          item.startTime.trim().replace(/:/g, '') - 0 == 0 && 0 == item.endTime.trim().replace(/:/g, '') - 0
            ? null
            : item.endTime
      })
    );
  }

  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;

  // 返回
  private toBack() {
    this.updateForm.resetFields();
    this.filterParam.parkId = '';
    this.filterParam.clientNumber = '';
    this.timeIntervalsList = [];
    this.closeCurrentTab();
    this.goBack('/smart-parking/parking-space-management/charging-package');
  }
}
